<template>
    <div class="callout callout-custom" role="alert">
        <button type="button" class="close" data-dismiss="callout" aria-label="Close" @click="back">
                    <span>×</span>
        </button>
        <h5>It seems you do not have a listener account.</h5>
        <p>Complete this form to create a listener account.</p>
        <bounce class="m-0" v-if="loadForm"></bounce>
        <form class="form-type-line mt-20" v-else>
            <div class="row">
              <div class="col-md-6">
                  <div class="form-group">
                    <label for="birth_month">Birth Month</label>
                    <multiselect v-model="birth_month" :options="month_list" 
                    :close-on-select="true" :show-labels="false" placeholder="Select your month">
                    </multiselect>
                  </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group">
                      <label for="birth_year">Birth Year</label>
                      <input type="number" class="form-control py-10" v-model="birth_year" id="birth_year" @blur="$v.birth_year.$touch()">
                      <div v-if="$v.birth_year.$dirty">
                        <div class="custom-error" v-if="!$v.birth_year.required">*Please enter your year of birth.</div>
                        <div class="custom-error" v-if="!$v.birth_year.minLength || !$v.birth_year.maxLength">*Year must be 4 digits</div>
                        <div class="custom-error" v-if="!$v.birth_year.maxValue">*Minimum age is 18.</div>
                      </div>
                  </div>
              </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="issues">Issues to Support</label>
                    <multiselect v-model="issues" :options="issues_list" track-by="id" label="title"  :multiple="true" 
                    :close-on-select="true" :show-labels="false" placeholder="Pick issues:">
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="languages">Fluent Languages</label>
                     <multiselect v-model="languages" :options="language_list" track-by="id" label="name" :multiple="true" 
                    :close-on-select="true" :show-labels="false" placeholder="Select languages:">
                    </multiselect>
                  </div>
                </div>
            </div>
                <div class="form-group">
                  <label>Choose a profile picture from the catalogue: </label>
                  <p v-if="avatars.length < 1">No Images in Catalogue.</p>
                  <div class="flex justify-content-start mb-20">
                      <span v-for="(avatar, i) in avatars" :key="i">
                        <a @click="chooseAvatar(avatar.id)" href="#"><img class="avatar b-1 border-primary mr-10" :id="avatar.id" :src="avatar.secure_url" alt="..." /></a>
                      </span>
                  </div>
                </div>
          </form>
          <button class="btn btn-bold btn-primary" disabled v-if="loading">
                <circle-spin class="m-0"></circle-spin>
            </button>
          <button class="btn btn-bold btn-primary" v-else type="button" @click="createListener" :disabled="checkData">Create Account</button>
    </div>
</template>

<script>
import axios from "axios";
import allMixins from '../../mixins.js'
import {
  required,
  email,
  numeric, maxValue, minLength, maxLength, sameAs
} from "vuelidate/lib/validators";

export default {
  mixins: [allMixins],
  data() {
    return {
      loadForm: true,
      loading: false,
      image: null,
        birth_month: "",
        month_list: ['January','February','March','April','May','June','July','August','September','October',
        'November','December'],
        birth_year: "",
        avatar_id: null,
        avatars:[],
        issues: [],
        issues_list: [],
        languages: [],
        language_list: []
    }
  },
   validations: {
    fname: { required },
    lname: { required },
    nickname: { required },
    email: {
      required,
      email
    },
    birth_year: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
      maxValue: maxValue(new Date().getFullYear() - 18)
    }
  },
  computed: {
    checkData() {
        if(this.birth_month == "" || this.birth_year == "" || this.languages.length < 1 || this.issues.length < 1 || this.avatar_id == null) {
            return true
        }
        else {
            return false
        }
    },
  },
  methods: {
     chooseAvatar(payload) {
       if(this.avatar_id != null) {
        document.getElementById(`${this.avatar_id}`).classList.remove('b-3')
        document.getElementById(`${this.avatar_id}`).classList.add('b-1')
       }
      
      document.getElementById(`${payload}`).classList.remove('b-1')
      document.getElementById(`${payload}`).classList.add('b-3')
      this.avatar_id = payload
      // console.log(this.avatar_id)
    },
    back() {
      this.$emit('back')
    },
    createListener() {
    let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
      let issues_id = []
      let languages_id = []
      for(var i=0; i < this.issues.length; i ++){
          issues_id.push(this.issues[i].id);
        }
      for(var i=0; i < this.languages.length; i ++){
          languages_id.push(this.languages[i].id);
      }
      let userData = {
        birthmonth: this.birth_month,
        birthyear: this.birth_year,
        issues: issues_id,
        languages: languages_id,
        avatar: this.avatar_id
      }
      this.loading = true
      axios.post(`/users/listener?id=${details.id}`, userData)
      .then(res => {
        this.loading= false
        // console.log(res)
        this.$notify({
          group: 'response',
          type: 'success',
          title: `${res.data.data.message}`,
          text: 'You have to log in again to access your new listener profile.',
          duration: 3500,
        })
        localStorage.clear()
        setTimeout(() => {
          this.$router.push('/login')
        }, 4000)
      })
      .catch(err => {
        this.loading= false
          this.$notify({
          group: 'response',
          type: 'error',
          text:  `${err.response.data.message}`,
          duration: 5000
        });
      })
    }
  },
  mounted() {
    this.loadForm = true
     axios.get('/admin/list?type=issue')
      .then(res => {
        let issues = res.data.data
        for(var i=0; i < issues.length; i ++){
          this.issues_list.push({id: issues[i].id, title: issues[i].title});
        }
        axios.get('/admin/list?type=language')
        .then(res => {
          let languages = res.data.data
          for(var i=0; i < languages.length; i ++){
            this.language_list.push({id: languages[i].id, name: languages[i].name});
          }
          axios.get('/users/avatars/all')
          .then(res => {
            this.loadForm = false
            this.avatars = res.data.results
          })
          .catch(err => {
            this.loadForm = false
            this.$notify({
              group: 'response',
              type: 'error',
              text: `${err.response.data.message}`,
              duration: 5000,
            });
          })
        })
        .catch(err=> {
          this.loadForm= false
          this.$notify({
            group: 'response',
            type: 'error',
            text: `${err.response.data.message}`,
            duration: 5000,
          });
        })
    })
    .catch(err => {
        this.loadForm = false
          this.$notify({
          group: 'response',
          type: 'error',
          text: `${err.response.data.message}`,
          duration: 5000,
        });
    })
  },
}
</script>
